import { state, patch, emitChange } from "../../state/store.js";
import { showToast } from "../../lib/toast.js";
import { applyMessageStatusToChats } from "../../views/Chat.helpers.ts";
import { applyChatPatch, applyChatTags, bumpChatPreview } from "./chat-state.js";

export function handleWhatsappSyncMessage(msg) {
  if (msg.op === "wa.qr.update" && msg.payload) {
    const session = state.whatsappSession || {};
    patch({ whatsappSession: { ...session, status: "qr", lastQrDataUrl: msg.payload.qrDataUrl } });
    return true;
  }
  if (msg.op === "wa.session.status" && msg.payload) {
    const session = state.whatsappSession || {};
    const next = { ...session, ...msg.payload };
    patch({ whatsappSession: next });
    if (next.status === "connected" && state.view === "onboarding") {
      patch({ view: "crm" });
      showToast(`WhatsApp conectado: +${next.phone || ""}`, "success");
    }
    return true;
  }
  if (msg.op === "wa.message.new" && msg.payload) {
    applyNewMessage(msg.payload);
    return true;
  }
  if (msg.op === "wa.message.update" && msg.payload) {
    applyMessageUpdate(msg.payload);
    return true;
  }
  if (msg.op === "wa.chat.update" && msg.payload) {
    applyChatPatch(msg.payload);
    return true;
  }
  if (msg.op === "wa.chat.tags" && msg.payload) {
    applyChatTags(msg.payload);
    return true;
  }
  return false;
}

function applyNewMessage(message) {
  const chatJid = message.chatJid;
  const list = state.chatMessages[chatJid] ? [...state.chatMessages[chatJid]] : [];
  if (!list.some((item) => item.messageKey === message.messageKey)) {
    list.push(message);
    list.sort((a, b) => (a.tsMs || 0) - (b.tsMs || 0));
  }
  state.chatMessages = { ...state.chatMessages, [chatJid]: list };
  bumpChatPreview(message);
  emitChange();
  if (!message.fromMe && state.activeChatJid !== chatJid && !message.isHistory) {
    const sender = message.senderName || message.senderJid || chatJid;
    showToast(`Nova msg: ${sender}`, "info");
  }
}

function applyMessageUpdate({ messageKey, status }) {
  let touched = false;
  for (const jid of Object.keys(state.chatMessages)) {
    const list = state.chatMessages[jid];
    const idx = list.findIndex((item) => item.messageKey === messageKey);
    if (idx >= 0) {
      list[idx] = { ...list[idx], status };
      touched = true;
    }
  }
  const nextChats = applyMessageStatusToChats(state.chats, messageKey, status);
  if (nextChats !== state.chats) {
    state.chats = nextChats;
    touched = true;
  }
  if (touched) emitChange();
}
